var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.190301 2.79329C0 3.25272 0 3.83515 0 5C0 6.16485 0 6.74728 0.190301 7.20671C0.444036 7.81928 0.930721 8.30596 1.54329 8.5597C2.00272 8.75 2.58515 8.75 3.75 8.75H16.25C17.4149 8.75 17.9973 8.75 18.4567 8.5597C19.0693 8.30596 19.556 7.81928 19.8097 7.20671C20 6.74728 20 6.16485 20 5C20 3.83515 20 3.25272 19.8097 2.79329C19.556 2.18072 19.0693 1.69404 18.4567 1.4403C17.9973 1.25 17.4149 1.25 16.25 1.25H3.75C2.58515 1.25 2.00272 1.25 1.54329 1.4403C0.930721 1.69404 0.444036 2.18072 0.190301 2.79329Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.190301 12.7933C0 13.2527 0 13.8351 0 15C0 16.1649 0 16.7473 0.190301 17.2067C0.444036 17.8193 0.930721 18.306 1.54329 18.5597C2.00272 18.75 2.58515 18.75 3.75 18.75H16.25C17.4149 18.75 17.9973 18.75 18.4567 18.5597C19.0693 18.306 19.556 17.8193 19.8097 17.2067C20 16.7473 20 16.1649 20 15C20 13.8351 20 13.2527 19.8097 12.7933C19.556 12.1807 19.0693 11.694 18.4567 11.4403C17.9973 11.25 17.4149 11.25 16.25 11.25H3.75C2.58515 11.25 2.00272 11.25 1.54329 11.4403C0.930721 11.694 0.444036 12.1807 0.190301 12.7933Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableView);
export default __webpack_public_path__ + "static/media/TableView.7804d965dd57fca6b8f33b228f353d3c.svg";
export { ForwardRef as ReactComponent };